/* eslint-disable-next-line no-restricted-imports */
import * as t from 'io-ts';

import { tCloudflareImage } from './cloudflareImage';

const tKioskAuthConfiguration = t.type({
  enabled: t.boolean,
  external_authentication_url: t.union([t.string, t.null]),
});

export type KioskAuthConfiguration = t.TypeOf<typeof tKioskAuthConfiguration>;

export const tKioskV2 = t.type({
  checkout_confirmation_message: t.union([t.string, t.null, t.undefined]),
  disable_birth_date_at_checkout: t.union([t.boolean, t.null]),
  disable_phone_number_at_checkout: t.union([t.boolean, t.null]),
  enabled: t.boolean,
  id: t.number,
  inactivity_timeout_ms: t.union([t.number, t.null]),
  kiosk_auth_configuration: t.union([tKioskAuthConfiguration, t.null]),
  kiosk_photo: t.union([tCloudflareImage, t.null]),
  refresh_to_landing_timeout_ms: t.union([t.number, t.null]),
  show_checkout_message_field: t.union([t.boolean, t.null]),
  show_medical_id_at_checkout: t.union([t.boolean, t.null]),
  show_medical_id_expiration_at_checkout: t.union([t.boolean, t.null]),
  skip_landing_page: t.union([t.boolean, t.null]),
});

export type KioskV2 = t.TypeOf<typeof tKioskV2>;
